import { NavLink } from "react-router-dom"

const GlobalNavLink = ({ type = null, to = "/", txt = "Un navlink de la landing page", css = "", img = null, picture = null }) => {

    const wSize = "w-[6.5rem]"
    const cssBtn = img ? `bg-white ${wSize} h-[4.5rem] px-6 pt-2 pb-1 flex flex-col gap-1 justify-center items-center border-2 border-darkRed rounded-lg ${css}` : `${css}`
    const cssSpan = type ? '' : `${wSize} flexJustifyItemsCenter`

    return (
        <NavLink to={to} className={cssBtn}>
            {img && <div className="h-6 w-6">{img}</div>}
            {picture ? picture : <span className={cssSpan}>{txt}</span>}
        </NavLink>
    )
}

export default GlobalNavLink